import Flickity from 'flickity';

function StartSlider() {
    var elem = document.querySelector('.main-carousel');
    if (!elem) {
        return;
    }
    new Flickity( elem, {
        // options
        cellAlign: 'left',
        contain: true,
        groupCells: true,
        adaptiveHeight: true,
    });
}

export default {
  init() {
      StartSlider();
  },
};
